import { AbstractCommand } from 'src/models/command';

class CreateAppointmentTimerCommand extends AbstractCommand {
	readonly name = 'IFS_Calendar_Command_Commands_CreateAppointmentTimer';
	readonly processId = 'random';

	public constructor(
		aggregateId: string,
		ifsAppointmentId: number,
		appointmentTypeId: number,
		startTime: string,
		endTime: null | string,
		title: string,
		appointmentRoundingMinutes: number
	) {
		super();

		this.parameters = {
			aggregateId: aggregateId,
			appointmentRoundingMinutes: appointmentRoundingMinutes,
			appointmentTypeId: appointmentTypeId,
			endTime: endTime,
			ifsAppointmentId: ifsAppointmentId,
			startTime: startTime,
			title: title,
		};
	}
}

export { CreateAppointmentTimerCommand };
